// extracted by mini-css-extract-plugin
module.exports = {"description":"list5_description__t_L9W"};